/** Map Musey's neutral lyrics to JIZURA without interpreting its editor markup. */
export function buildJizuraTimeline(payload, durationSec) {
  const suppliedDuration = Number(durationSec)
  const knownDuration = Number.isFinite(suppliedDuration) && suppliedDuration > 0
    ? suppliedDuration : 0
  let rows = []
  const approximate = payload?.kind === 'plain'
  if (payload?.kind === 'sync' && Array.isArray(payload.lines)) {
    rows = payload.lines
      .map((row) => ({ text: String(row?.text ?? ''), start: Number(row?.start), end: Number(row?.end) }))
      .filter((row) => Number.isFinite(row.start) && row.start >= 0)
      .sort((a, b) => a.start - b.start)
    rows = rows.map((row, index) => ({
      ...row,
      end: Number.isFinite(row.end) && row.end > row.start
        ? row.end : (rows[index + 1]?.start ?? (knownDuration || row.start + 4)),
    }))
  } else if (approximate) {
    const texts = String(payload.text || '').split(/\r?\n/).map((text) => text.trim()).filter(Boolean)
    const slot = knownDuration && texts.length ? knownDuration / texts.length : 4
    rows = texts.map((text, index) => ({ text, start: index * slot, end: (index + 1) * slot }))
  }
  const duration = knownDuration || Math.max(4, ...rows.map((row) => row.end))
  const lines = []
  const starts = []
  const ends = []
  const append = (text, start, end) => {
    const interlude = !text.trim()
    lines.push({
      text, interlude, secs: interlude ? end - start : null,
      lrc: start, src: lines.length, gapBefore: false,
      note: null, impact: false, emph: [], manual: null,
    })
    starts.push(start)
    ends.push(end)
  }
  let cursor = 0
  rows.forEach((row, index) => {
    const end = Math.min(row.end, rows[index + 1]?.start ?? duration, duration)
    if (row.start >= duration || end <= row.start || row.start < cursor) return
    if (!lines.length && !row.text.trim()) return
    if (row.start > cursor && cursor > 0) append('', cursor, row.start)
    append(row.text, row.start, end)
    cursor = end
  })
  if (cursor < duration) append('', cursor, duration)
  return { parsed: { lines, meta: {} }, starts, ends, duration, approximate }
}
